let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dgcws")).then(() => parcelRequire('5IP1I'));